import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../Shared/Layout";
import {
    Grid,
    makeStyles,
} from "@material-ui/core";
import styled from "styled-components";
import EditIcon from "@material-ui/icons/Edit";
import { Inertia } from "@inertiajs/inertia";
import MuiButton from "@material-ui/core/Button";
import { Field, Form as FinalForm } from "react-final-form";
import { getCookieValue } from "../../utils/getCookieValue";
import { Trans } from "../../utils/i18n";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import PersonIcon from '@material-ui/icons/Person';
import { appointment } from "../../config/appointment";
import { queueDetailConfigPyramid } from "../../config/queueDetailPyramid";
import { Chat } from "../../Shared/Chat";
import dayjs from "dayjs";
import Paper from "@material-ui/core/Paper";
import { Alert } from "@material-ui/lab";
import { AddressShowEdit } from "../../Shared/AddressShowEdit";
import Wrapper from "./Wrapper";

const DetailsHeading = styled.h4`
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 0;
`;

const DetailsValue = styled.h4`
    font-size: 16px;
    font-weight: 500;
    margin-top: 5px;
    position: relative;
`;

const EditButton = styled.div`
    position: absolute;
    top: 0;
    right: 15px;
    cursor: pointer;
`;

const ResponseWrapper = styled.div`
    width: 100%;
    margin-top: 30px;
`;

const createConditionFilter = (values, state) => (fieldOrGroup, step) => {
    if (!fieldOrGroup.condition) {
        return true;
    }

    const paths = fieldOrGroup.condition.field
        .replace(/\[(.*)\]/gm, ".$1")
        .split(".");

    let value = paths.reduce((values, path) => values[path], values);

    if (fieldOrGroup.condition.compare === "!=") {
        if (value === undefined) {
            return null !== fieldOrGroup.condition.value;
        }
        return value !== fieldOrGroup.condition.value;
    }

    return value === fieldOrGroup.condition.value;
};

export default function Contact({
    client,
    order,
    statuses,
    services,
    partners,
    coverages,
    settlements,
    materialOperations,
    files,
    userCanUpdate,
    orderattributes,
    orderhistories,
    extendedMode,
    permissions,
    returnUrl,
}) {
    const [formState, setFormState] = useState(undefined);
    const [response, setResponse] = useState(undefined);
    const [editAddress, setEditAddress] = useState(false);

    const onSubmit = async (data) => {
        setFormState("loading");
        await fetch(route("queue.store"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-XSRF-TOKEN": getCookieValue("XSRF-TOKEN"),
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
                ...data,
                returnUrl,
            }),
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.success) {
                    setFormState("success");
                    setResponse("");
                    Inertia.visit(
                        returnUrl ||
                            route("queue.index", {
                                requesttype: order.requesttype_key,
                            })
                    );
                    return;
                }
                setResponse(response);
                setFormState("error");
            })
            .catch(() => {
                setFormState("error");
            });
    };

    return (
        <Wrapper>
            {order.permissions.order.viewInstallationAddress && (
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        {editAddress !== "installation_address" && (
                            <>
                                <DetailsHeading>
                                    <Trans i18nKey="queueDetail.address">
                                        Address
                                    </Trans>
                                </DetailsHeading>
                                <DetailsValue>
                                    {order.installation_address.name}
                                    <br />
                                    {order.installation_address.name_2}
                                    <br />
                                    {order.installation_address.street} {order.installation_address.housenumber}
                                    <br />
                                    {order.installation_address.zip}{" "}
                                    {order.installation_address.city}
                                    <br />
                                    {order.installation_address?.country?.name}
                                    {order.permissions.order.updateAddress && (
                                        <EditButton
                                            onClick={() => {
                                                setEditAddress(
                                                    "installation_address"
                                                );
                                            }}
                                        >
                                            <EditIcon />
                                        </EditButton>
                                    )}
                                </DetailsValue>
                            </>
                        )}
                        {editAddress === "installation_address" && (
                            <AddressShowEdit
                                order={order}
                                setEditAddress={setEditAddress}
                                type={"installation_address"}
                            />
                        )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        {editAddress !== "contact" && (
                            <>
                                <DetailsHeading>
                                    <Trans i18nKey="queueDetail.contact">
                                        Contact
                                    </Trans>
                                </DetailsHeading>
                                <DetailsValue>
                                    {order.installation_address.contact_name && (
                                        <>
                                            <div>
                                                <PersonIcon />{" "}
                                                <span>
                                                    {
                                                        order
                                                            .installation_address
                                                            .contact_name
                                                    }
                                                </span>
                                            </div>
                                            <br />
                                        </>
                                    )}
                                    {order.installation_address.phone && (
                                        <>
                                            <div>
                                                <PhoneIcon />{" "}
                                                <span>
                                                    {
                                                        order
                                                            .installation_address
                                                            .phone
                                                    }
                                                </span>
                                            </div>
                                            <br />
                                        </>
                                    )}
                                    {order.installation_address.mobile && (
                                        <>
                                            <div>
                                                <PhoneIphoneIcon />{" "}
                                                <span>
                                                    {
                                                        order
                                                            .installation_address
                                                            .mobile
                                                    }
                                                </span>
                                            </div>
                                            <br />
                                        </>
                                    )}
                                    {order.installation_address.email && (
                                        <div>
                                            <EmailIcon />{" "}
                                            <span>
                                                {
                                                    order.installation_address
                                                        .email
                                                }
                                            </span>
                                        </div>
                                    )}
                                    {order.permissions.order.updateAddress && (
                                        <EditButton
                                            onClick={() => {
                                                setEditAddress("contact");
                                            }}
                                        >
                                            <EditIcon />
                                        </EditButton>
                                    )}
                                </DetailsValue>
                            </>
                        )}
                        {editAddress === "contact" && (
                            <AddressShowEdit
                                order={order}
                                setEditAddress={setEditAddress}
                                type={"contact"}
                            />
                        )}
                    </Grid>
                </Grid>
            )}

            {order.permissions.order.viewDeliveryAddress &&
                order.delivery_address && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
                            {editAddress !== "delivery_address" && (
                                <>
                                    <DetailsHeading>
                                        <Trans i18nKey="queueDetail.deliveryAddress">
                                            Delivery address
                                        </Trans>
                                    </DetailsHeading>
                                    <DetailsValue>
                                        {order.delivery_address?.name}
                                        <br />
                                        {order.delivery_address?.name_2}
                                        <br />
                                        {order.delivery_address?.street} {order.delivery_address?.housenumber}
                                        <br />
                                        {order.delivery_address?.zip}{" "}
                                        {order.delivery_address?.city}
                                        <br />
                                        {order.delivery_address?.country?.name}
                                        {order.permissions.order
                                            .updateAddress && (
                                            <EditButton
                                                onClick={() => {
                                                    setEditAddress(
                                                        "delivery_address"
                                                    );
                                                }}
                                            >
                                                <EditIcon />
                                            </EditButton>
                                        )}
                                    </DetailsValue>
                                </>
                            )}
                            {editAddress === "delivery_address" && (
                                <AddressShowEdit
                                    order={order}
                                    setEditAddress={setEditAddress}
                                    type={"delivery_address"}
                                />
                            )}
                        </Grid>

                        <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
                            {editAddress !== "delivery_contact" && (
                                <>
                                    <DetailsHeading>
                                        <Trans i18nKey="queueDetail.deliveryContact">
                                            Delivery contact
                                        </Trans>
                                    </DetailsHeading>
                                    <DetailsValue>
                                        {order.delivery_address.contact_name && (
                                            <>
                                                <div>
                                                    <PersonIcon />{" "}
                                                    <span>
                                                        {
                                                            order
                                                                .delivery_address
                                                                .contact_name
                                                        }
                                                    </span>
                                                </div>
                                                <br />
                                            </>
                                        )}
                                        {order.delivery_address.phone && (
                                            <>
                                                <div>
                                                    <PhoneIcon />{" "}
                                                    <span>
                                                        {
                                                            order
                                                                .delivery_address
                                                                .phone
                                                        }
                                                    </span>
                                                </div>
                                                <br />
                                            </>
                                        )}
                                        {order.delivery_address.email && (
                                            <div>
                                                <EmailIcon />{" "}
                                                <span>
                                                    {
                                                        order.delivery_address
                                                            .email
                                                    }
                                                </span>
                                            </div>
                                        )}
                                        {order.permissions.order
                                            .updateAddress && (
                                            <EditButton
                                                onClick={() => {
                                                    setEditAddress(
                                                        "delivery_contact"
                                                    );
                                                }}
                                            >
                                                <EditIcon />
                                            </EditButton>
                                        )}
                                    </DetailsValue>
                                </>
                            )}
                            {editAddress === "delivery_contact" && (
                                <AddressShowEdit
                                    order={order}
                                    setEditAddress={setEditAddress}
                                    type={"delivery_contact"}
                                />
                            )}
                        </Grid>
                    </Grid>
                )}

            {order.permissions.order.viewInvoiceAddress &&
                order.invoice_address && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
                            {editAddress !== "invoice_address" && (
                                <>
                                    <DetailsHeading>
                                        <Trans i18nKey="queueDetail.invoiceAddress">
                                            Invoice address
                                        </Trans>
                                    </DetailsHeading>
                                    <DetailsValue>
                                        {order.invoice_address?.name}
                                        <br />
                                        {order.invoice_address?.name_2}
                                        <br />
                                        {order.invoice_address?.street} {order.invoice_address?.housenumber}
                                        <br />
                                        {order.invoice_address?.zip}{" "}
                                        {order.invoice_address?.city}
                                        <br />
                                        {order.invoice_address?.country?.name}
                                        {order.permissions.order
                                            .updateAddress && (
                                            <EditButton
                                                onClick={() => {
                                                    setEditAddress(
                                                        "invoice_address"
                                                    );
                                                }}
                                            >
                                                <EditIcon />
                                            </EditButton>
                                        )}
                                    </DetailsValue>
                                </>
                            )}
                            {editAddress === "invoice_address" && (
                                <AddressShowEdit
                                    order={order}
                                    setEditAddress={setEditAddress}
                                    type={"invoice_address"}
                                />
                            )}
                        </Grid>

                        <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
                            {editAddress !== "invoice_contact" && (
                                <>
                                    <DetailsHeading>
                                        <Trans i18nKey="queueDetail.invoiceContact">
                                            Invoice contact
                                        </Trans>
                                    </DetailsHeading>
                                    <DetailsValue>
                                        {order.invoice_address.contact_name && (
                                            <>
                                                <div>
                                                    <PersonIcon />{" "}
                                                    <span>
                                                        {
                                                            order
                                                                .invoice_address
                                                                .contact_name
                                                        }
                                                    </span>
                                                </div>
                                                <br />
                                            </>
                                        )}
                                        {order.invoice_address.phone && (
                                            <>
                                                <div>
                                                    <PhoneIcon />{" "}
                                                    <span>
                                                        {
                                                            order
                                                                .invoice_address
                                                                .phone
                                                        }
                                                    </span>
                                                </div>
                                                <br />
                                            </>
                                        )}
                                        {order.invoice_address.email && (
                                            <div>
                                                <EmailIcon />{" "}
                                                <span>
                                                    {
                                                        order.invoice_address
                                                            .email
                                                    }
                                                </span>
                                            </div>
                                        )}
                                        {order.permissions.order
                                            .updateAddress && (
                                            <EditButton
                                                onClick={() => {
                                                    setEditAddress(
                                                        "invoice_contact"
                                                    );
                                                }}
                                            >
                                                <EditIcon />
                                            </EditButton>
                                        )}
                                    </DetailsValue>
                                </>
                            )}
                            {editAddress === "invoice_contact" && (
                                <AddressShowEdit
                                    order={order}
                                    setEditAddress={setEditAddress}
                                    type={"invoice_contact"}
                                />
                            )}
                        </Grid>
                    </Grid>
                )}

            {order.permissions.order.viewCollectionAddress &&
                order.collection_address && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
                            {editAddress !== "collection_address" && (
                                <>
                                    <DetailsHeading>
                                        <Trans i18nKey="queueDetail.collectionAddress">
                                            Collection address
                                        </Trans>
                                    </DetailsHeading>
                                    <DetailsValue>
                                        {order.collection_address?.name}
                                        <br />
                                        {order.collection_address?.name_2}
                                        <br />
                                        {order.collection_address?.street} {order.collection_address?.housenumber}
                                        <br />
                                        {order.collection_address?.zip}{" "}
                                        {order.collection_address?.city}
                                        <br />
                                        {
                                            order.collection_address?.country
                                                ?.name
                                        }
                                        {order.permissions.order
                                            .updateAddress && (
                                            <EditButton
                                                onClick={() => {
                                                    setEditAddress(
                                                        "collection_address"
                                                    );
                                                }}
                                            >
                                                <EditIcon />
                                            </EditButton>
                                        )}
                                    </DetailsValue>
                                </>
                            )}
                            {editAddress === "collection_address" && (
                                <AddressShowEdit
                                    order={order}
                                    setEditAddress={setEditAddress}
                                    type={"collection_address"}
                                />
                            )}
                        </Grid>

                        <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
                            {editAddress !== "collection_contact" && (
                                <>
                                    <DetailsHeading>
                                        <Trans i18nKey="queueDetail.collectionContact">
                                            Collection contact
                                        </Trans>
                                    </DetailsHeading>
                                    <DetailsValue>
                                        {order.collection_address.contact_name && (
                                            <>
                                                <div>
                                                    <PersonIcon />{" "}
                                                    <span>
                                                        {
                                                            order
                                                                .collection_address
                                                                .contact_name
                                                        }
                                                    </span>
                                                </div>
                                                <br />
                                            </>
                                        )}
                                        {order.collection_address.phone && (
                                            <>
                                                <div>
                                                    <PhoneIcon />{" "}
                                                    <span>
                                                        {
                                                            order
                                                                .collection_address
                                                                .phone
                                                        }
                                                    </span>
                                                </div>
                                                <br />
                                            </>
                                        )}
                                        {order.collection_address.email && (
                                            <div>
                                                <EmailIcon />{" "}
                                                <span>
                                                    {
                                                        order.collection_address
                                                            .email
                                                    }
                                                </span>
                                            </div>
                                        )}
                                        {order.permissions.order
                                            .updateAddress && (
                                            <EditButton
                                                onClick={() => {
                                                    setEditAddress(
                                                        "collection_contact"
                                                    );
                                                }}
                                            >
                                                <EditIcon />
                                            </EditButton>
                                        )}
                                    </DetailsValue>
                                </>
                            )}
                            {editAddress === "collection_contact" && (
                                <AddressShowEdit
                                    order={order}
                                    setEditAddress={setEditAddress}
                                    type={"collection_contact"}
                                />
                            )}
                        </Grid>
                    </Grid>
                )}

            <FinalForm initialValues={order} onSubmit={onSubmit}>
                {({
                    handleSubmit,
                    submitting,
                    values,
                    form,
                    errors,
                    touched,
                }) => {
                    const currentStatus = statuses.find(
                        (item) => item.id == values.status_id
                    );
                    const currentService = services.find(
                        (item) => item.id == values.service_id
                    );
                    const currentSettlement = settlements.find(
                        (item) => item.id == values.settlement_id
                    );
                    const conditionFilter = useMemo(
                        () => createConditionFilter(values),
                        [values]
                    );
                    let preFix = "";

                    return (
                        <form onSubmit={handleSubmit}>
                            <div className={'flex justify-end gap-3 mt-10'}>
                                {permissions.includes(
                                    "queue_shipping_label"
                                ) && (
                                    <MuiButton
                                        variant="contained"
                                        color={"primary"}
                                        disabled={
                                            submitting ||
                                            currentStatus.key === "created" ||
                                            currentStatus.key === "closed" ||
                                            currentStatus.key === "canceled"
                                        }
                                        href={route("queue.shippinglabel", {
                                            ordernumber: order.number,
                                        })}
                                        target="_blank"
                                    >
                                        <Trans i18nKey="queueDetail.shippingLabelButton">
                                            CREATE SHIPPING LABEL
                                        </Trans>
                                    </MuiButton>
                                )}
                                {extendedMode && (
                                    <MuiButton
                                        variant="contained"
                                        disabled={submitting}
                                        onClick={() =>
                                            Inertia.visit(
                                                route("queue.index", {
                                                    requesttype:
                                                        order.requesttype_key,
                                                })
                                            )
                                        }
                                    >
                                        <Trans i18nKey="queueDetail.cancel">
                                            Cancel
                                        </Trans>
                                    </MuiButton>
                                )}
                                {/* <MuiButton
                                    variant="contained"
                                    color={"secondary"}
                                    disabled={
                                        submitting ||
                                        !order.permissions.order.updateAddress
                                    }
                                    type={"submit"}
                                    onClick={() => {
                                        form.change("saveAndCloseJob", false);
                                    }}
                                >
                                    <Trans i18nKey="queueDetail.save">
                                        Save
                                    </Trans>
                                </MuiButton> */}
                                {extendedMode == false && (
                                    <MuiButton
                                        variant="contained"
                                        color={"secondary"}
                                        disabled={
                                            submitting ||
                                            !order.permissions.order
                                                .updateAddress ||
                                            currentStatus.key === "closed"
                                        }
                                        type={"submit"}
                                        onClick={() => {
                                            form.change(
                                                "saveAndCloseJob",
                                                true
                                            );
                                        }}
                                    >
                                        <Trans i18nKey="queueDetail.saveAndClose">
                                            Save & close job
                                        </Trans>
                                    </MuiButton>
                                )}
                                <br />
                            </div>
                            <ResponseWrapper>
                                {response?.message && (
                                    <Alert severity="warning">
                                        {response?.message}
                                    </Alert>
                                )}
                            </ResponseWrapper>
                        </form>
                    );
                }}
            </FinalForm>
        </Wrapper>
    );
}

Contact.layout = (page) => <Layout children={page} />;
